<style>
  /* Övergripande container med padding */
  .container {
    padding: 20px;
  }

  /* Flexbox för två kolumner med gap och wrap */
  .columns {
    display: flex;
    flex-wrap: wrap;
    gap: 30px;
  }
  /* Varje kolumn tar lika mycket utrymme, men kan staplas på mindre skärmar */
  .column {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 300px; /* Säkerställer att kolumnerna inte blir för smala */
  }
    /* Marginal under varje mat-card */
    .column mat-card {
      margin-bottom: 30px;
    }

  .warning-box {
    border: 1px solid red;
    background-color: #ffe5e5; /* Light red background */
    padding: 20px;
    margin: 10px auto 20px auto;
    font-weight: bold;
  }

  .greeting-muted {
    color: #3f3f41;
    font-size: 1.6rem;
    margin-top: 0;
  }
</style>

<div class="container" *ngIf="user">
  <!-- Hälsningsmeddelande -->
  <h1 class="greeting greeting-muted sam-page-heading" *ngIf="user">
    Hej <span class="accent">{{ user.FirstName}}</span>, välkommen tillbaka!
  </h1>

  <!-- Varning vid spärrat konto -->
  <div *ngIf="user.suspended" class="warning-box">
    Ditt konto är spärrat pga misstänkt missbruk eller brott mot våra villkor. Kontakta supporten.
  </div>

  <!-- Wrapper med bakgrundsformatering -->
  <div class="backgroundColor">
    <!-- Två kolumner -->
    <div class="columns">
      <!-- Vänster kolumn: Personligt eller företagsinnehåll -->
      <div class="column">
        <!-- Personligt konto (appId 1) -->
        <ng-container *ngIf="appId === 1">
          <!-- Kommande löner -->
          <mat-card>
            <mat-card-title>
              <h4 class="incomeTextHead accent">Kommande löner</h4>
            </mat-card-title>
            <mat-card-subtitle>
              <p class="incomeText">
                Nedan är preliminära utbetalningar, för mer detaljer gå till din
                <a href="#/transactions"><span class="accent">ekonomisida</span></a>
              </p>
            </mat-card-subtitle>
            <mat-card-content>
              <div class="example-container mat-elevation-z0 economy">
                <div class="upcoming-payout-skeleton" *ngIf="isInvoiceLoading" aria-hidden="true">
                  <div class="upcoming-payout-skeleton__row" *ngFor="let row of invoiceSkeletonRows">
                    <span class="upcoming-payout-skeleton__icon"></span>
                    <span class="upcoming-payout-skeleton__bar upcoming-payout-skeleton__bar--customer"></span>
                    <span class="upcoming-payout-skeleton__bar upcoming-payout-skeleton__bar--date"></span>
                    <span class="upcoming-payout-skeleton__bar upcoming-payout-skeleton__bar--amount"></span>
                  </div>
                </div>
                <mat-table class="myTable" [dataSource]="dataSource" *ngIf="!isInvoiceLoading">
                  <!-- Ikonkolumn -->
                  <ng-container matColumnDef="icon">
                    <mat-header-cell *matHeaderCellDef fxShow="false" fxShow.gt-sm></mat-header-cell>
                    <mat-cell *matCellDef="let element" fxShow="false" fxShow.gt-sm>
                      <mat-icon color="accent">description</mat-icon>
                    </mat-cell>
                  </ng-container>
                  <!-- Kundkolumn -->
                  <ng-container matColumnDef="customer">
                    <mat-header-cell *matHeaderCellDef fxShow="false" fxShow.gt-sm>
                      <span class="accent">Kund:</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" fxShow="false" fxShow.gt-sm>
                      <span *ngIf="element.Customer != null">{{ element.Customer.Name }}</span>
                      <span *ngIf="element.Customer == null">{{ element.RecieverCompanyName }}</span>
                    </mat-cell>
                  </ng-container>
                  <!-- Preliminärt datum -->
                  <ng-container matColumnDef="paymentdue">
                    <mat-header-cell *matHeaderCellDef fxShow="false" fxShow.gt-sm>
                      <span class="accent">
                        Prel. datum:
                        <mat-icon class="iconPreli" matTooltip="Du kan förvänta dig betalning 1-2 dagar efter datumet" color="accent">info</mat-icon>
                      </span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" class="paymentdue-margin" fxShow="false" fxShow.gt-sm>
                      <span [ngStyle]="{'font-style': getUpcomingPayoutLog(element)?.IsPreliminary ? 'italic' : 'inherit' }">
                        {{ element.PaymentDue | swedishDate:'yyyy-MM-dd' }}
                      </span>
                      <span *ngIf="getUpcomingPayoutLog(element)?.IsPreliminary">
                        <mat-icon class="iconPreli" matTooltip="Detta är ett preliminärt datum" color="accent">info</mat-icon>
                      </span>
                    </mat-cell>
                  </ng-container>
                  <!-- Belopp -->
                  <ng-container matColumnDef="money">
                    <mat-header-cell *matHeaderCellDef fxShow="false" fxShow.gt-sm>
                      <span class="accent">Belopp:</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" class="money-less" fxShow="false" fxShow.gt-sm>
                      <ng-container *ngIf="getUpcomingPayoutAmount(element) as upcomingPayout">
                        {{ upcomingPayout | number: '1.0-2' }} SEK
                      </ng-container>
                    </mat-cell>
                  </ng-container>
                  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                </mat-table>
              </div>
            </mat-card-content>
          </mat-card>

          <!-- Kalkylator -->
          <mat-card class="calculator-card">
            <mat-card-title>
              <h4 class="incomeTextHead accent">Kalkylator</h4>
            </mat-card-title>
            <mat-card-content>
              <mat-tab-group color="accent" mat-stretch-tabs dynamicHeight>
                <!-- Tab 1: Din Lön -->
                <mat-tab>
                  <ng-template mat-tab-label>
                    <mat-icon color="accent">attach_money</mat-icon>
                    Din Lön
                  </ng-template>
                  <div class="d-flex justify-content-start calc-slider">
                    <mat-slide-toggle [(ngModel)]="samFeeSlide">Express?</mat-slide-toggle>
                  </div>
                  <!-- Normal kalkylator -->
                  <div *ngIf="!samFeeSlide">
                    <div class="d-flex justify-content-center">
                      <mat-form-field class="calc">
                        <mat-label>Belopp du ska fakturera</mat-label>
                        <input matInput type="number" [disabled]="user.Municipality.Tax == 0" [(ngModel)]="totalInvoiceAmount" (ngModelChange)="myCalculator($event)">
                        <mat-icon matSuffix color="accent">description</mat-icon>
                      </mat-form-field>
                    </div>
                    <div class="d-flex justify-content-center">
                      <mat-form-field class="calc">
                        <mat-label>Belopp efter skatt</mat-label>
                        <input matInput type="number" [disabled]="user.Municipality.Tax == 0" readonly [(ngModel)]="netSalary">
                        <mat-icon matSuffix color="accent">money</mat-icon>
                      </mat-form-field>
                    </div>
                    <div class="d-flex justify-content-center" *ngIf="totalInvoiceAmount">
                      <mat-expansion-panel (opened)="panelOpenStateCalc = true" (closed)="panelOpenStateCalc = false" class="calcExpand mat-elevation-z0" hideToggle>
                        <mat-expansion-panel-header class="calcHeaderPanel">
                          <mat-panel-title>
                            Se hur vi har räknat&nbsp;
                            <mat-icon *ngIf="!panelOpenStateCalc" color="accent">add</mat-icon>
                            <mat-icon *ngIf="panelOpenStateCalc" color="accent">remove</mat-icon>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div>
                          <div class="d-flex justify-content-between">
                            <b class="marginCalctext">Fakturabelopp exkl. moms:</b>
                            <p><span class="accent">{{ totalInvoiceAmount }}</span> SEK</p>
                          </div>
                          <div class="d-flex justify-content-between">
                            <b class="marginCalctext">SAMpoolen-avgift:</b>
                            <p><span class="accent">{{ samFeeNew }}</span> SEK</p>
                          </div>
                          <div class="d-flex justify-content-between">
                            <b class="marginCalctext">Sociala avgifter:</b>
                            <p><span class="accent">{{ arbetsgivarAvgift }}</span> SEK</p>
                          </div>
                          <div class="d-flex justify-content-between">
                            <b class="marginCalctext">Bruttolön:</b>
                            <p><span class="accent">{{ grossSalary }}</span> SEK</p>
                          </div>
                          <div class="d-flex justify-content-between">
                            <b class="marginCalctext">Kommunalskatt ({{municipalitytax * 100 | number:'1.2-2'}} %):</b>
                            <p><span class="accent">{{ displayTax }}</span> SEK</p>
                          </div>
                          <div class="d-flex justify-content-between">
                            <b class="marginCalctext">Nettolön:</b>
                            <p><span class="accent">{{ netSalary }}</span> SEK</p>
                          </div>
                        </div>
                      </mat-expansion-panel>
                    </div>
                  </div>
                  <!-- Express kalkylator -->
                  <div *ngIf="samFeeSlide">
                    <div class="d-flex justify-content-center">
                      <mat-form-field class="calc">
                        <mat-label>Belopp du ska fakturera</mat-label>
                        <input matInput type="number" [disabled]="user.Municipality.Tax == 0" [(ngModel)]="totalInvoiceAmountExpress" (ngModelChange)="myExpressCalculator($event)">
                        <mat-icon matSuffix color="accent">description</mat-icon>
                      </mat-form-field>
                    </div>
                    <div class="d-flex justify-content-center">
                      <mat-form-field class="calc">
                        <mat-label>Belopp efter skatt</mat-label>
                        <input matInput type="number" [disabled]="user.Municipality.Tax == 0" readonly [(ngModel)]="netSalaryExpress">
                        <mat-icon matSuffix color="accent">money</mat-icon>
                      </mat-form-field>
                    </div>
                    <div class="d-flex justify-content-center" *ngIf="totalInvoiceAmountExpress">
                      <mat-expansion-panel (opened)="panelOpenStateCalc = true" (closed)="panelOpenStateCalc = false" class="calcExpand mat-elevation-z0" hideToggle>
                        <mat-expansion-panel-header class="calcHeaderPanel">
                          <mat-panel-title>
                            Se hur vi har räknat&nbsp;
                            <mat-icon *ngIf="!panelOpenStateCalc" color="accent">add</mat-icon>
                            <mat-icon *ngIf="panelOpenStateCalc" color="accent">remove</mat-icon>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div>
                          <div class="d-flex justify-content-between">
                            <b class="marginCalctext">Fakturabelopp exkl. moms:</b>
                            <p><span class="accent">{{ totalInvoiceAmountExpress }}</span> SEK</p>
                          </div>
                          <div class="d-flex justify-content-between">
                            <b class="marginCalctext">SAMpoolen-avgift  ({{samFeeExpress * 100}} %):</b>
                            <p><span class="accent">{{ samFeeNew }}</span> SEK</p>
                          </div>
                          <div class="d-flex justify-content-between">
                            <b class="marginCalctext">Sociala avgifter:</b>
                            <p><span class="accent">{{ arbetsgivarAvgift }}</span> SEK</p>
                          </div>
                          <div class="d-flex justify-content-between">
                            <b class="marginCalctext">Bruttolön:</b>
                            <p><span class="accent">{{ grossSalary }}</span> SEK</p>
                          </div>
                          <div class="d-flex justify-content-between">
                            <b class="marginCalctext">Kommunalskatt  ({{municipalitytax * 100 | number:'1.2-2'}} %):</b>
                            <p><span class="accent">{{ displayTax }}</span> SEK</p>
                          </div>
                          <div class="d-flex justify-content-between">
                            <b class="marginCalctext">Nettolön:</b>
                            <p><span class="accent">{{ netSalaryExpress }}</span> SEK</p>
                          </div>
                        </div>
                      </mat-expansion-panel>
                    </div>
                  </div>
                </mat-tab>
                <!-- Tab 2: Inkl / exkl moms -->
                <mat-tab>
                  <ng-template mat-tab-label>
                    <mat-icon color="accent">shuffle</mat-icon>
                    Inkl / exkl moms
                  </ng-template>
                  <div class="totalInvoice">
                    <p>
                      Räkna ut hur stor en summa (utan moms) blir om du lägger på moms, eller tvärt om.
                    </p>
                    <div class="d-flex justify-content-center">
                      <mat-button-toggle-group name="changeVat" [(ngModel)]="vatButton">
                        <mat-button-toggle [value]="1" mat-button>25%</mat-button-toggle>
                        <mat-button-toggle [value]="2" mat-button>12%</mat-button-toggle>
                        <mat-button-toggle [value]="3" mat-button>6%</mat-button-toggle>
                        <mat-button-toggle [value]="4" mat-button>0%</mat-button-toggle>
                      </mat-button-toggle-group>
                    </div>
                    <div *ngIf="vatButton == 1">
                      <div class="d-flex">
                        <mat-form-field class="col-6">
                          <mat-label>Belopp utan 25% moms</mat-label>
                          <input matInput type="number" [(ngModel)]="noVat" (ngModelChange)="myVatCalc($event)">
                          <mat-icon matSuffix color="accent">money</mat-icon>
                        </mat-form-field>
                        <mat-form-field class="col-6">
                          <mat-label>Belopp med 25% moms</mat-label>
                          <input matInput type="number" [(ngModel)]="withVat" (ngModelChange)="myNoVatCalc($event)">
                          <mat-icon matSuffix color="accent">money</mat-icon>
                        </mat-form-field>
                      </div>
                    </div>
                    <div *ngIf="vatButton == 2">
                      <div class="d-flex">
                        <mat-form-field class="col-6">
                          <mat-label>Belopp utan 12% moms</mat-label>
                          <input matInput type="number" [(ngModel)]="noVatMedium" (ngModelChange)="myVatCalcMedium($event)">
                          <mat-icon matSuffix color="accent">money</mat-icon>
                        </mat-form-field>
                        <mat-form-field class="col-6">
                          <mat-label>Belopp med 12% moms</mat-label>
                          <input matInput type="number" [(ngModel)]="withVatMedium" (ngModelChange)="myNoVatCalcMedium($event)">
                          <mat-icon matSuffix color="accent">money</mat-icon>
                        </mat-form-field>
                      </div>
                    </div>
                    <div *ngIf="vatButton == 3">
                      <div class="d-flex">
                        <mat-form-field class="col-6">
                          <mat-label>Belopp utan 6% moms</mat-label>
                          <input matInput type="number" [(ngModel)]="noVatLow" (ngModelChange)="myVatCalcLow($event)">
                          <mat-icon matSuffix color="accent">money</mat-icon>
                        </mat-form-field>
                        <mat-form-field class="col-6">
                          <mat-label>Belopp med 6% moms</mat-label>
                          <input matInput type="number" [(ngModel)]="withVatLow" (ngModelChange)="myNoVatCalcLow($event)">
                          <mat-icon matSuffix color="accent">money</mat-icon>
                        </mat-form-field>
                      </div>
                    </div>
                    <div *ngIf="vatButton == 4">
                      <div class="d-flex">
                        <mat-form-field class="col-6">
                          <mat-label>Belopp utan 0% moms</mat-label>
                          <input matInput type="number" [(ngModel)]="noVatLow">
                          <mat-icon matSuffix color="accent">money</mat-icon>
                        </mat-form-field>
                        <mat-form-field class="col-6">
                          <mat-label>Belopp med 0% moms</mat-label>
                          <input matInput type="number" [(ngModel)]="noVatLow">
                          <mat-icon matSuffix color="accent">money</mat-icon>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </mat-tab>
              </mat-tab-group>
            </mat-card-content>
          </mat-card>
        </ng-container>

        <!-- Företagskonto (appId 2) -->
        <ng-container *ngIf="appId === 2">
          <!-- Skickade fakturor -->
          <mat-card>
            <mat-card-title>
              <h4 class="incomeTextHead accent">Skickade fakturor</h4>
            </mat-card-title>
            <mat-card-subtitle>
              <p class="incomeText">Här är dina senaste fakturor</p>
            </mat-card-subtitle>
            <mat-card-content>
              <div class="example-container mat-elevation-z0 economy">
                <mat-table class="myTable" [dataSource]="dataSource">
                  <!-- Fakturanummer -->
                  <ng-container matColumnDef="invoicenumbercomp">
                    <mat-header-cell *matHeaderCellDef fxShow="false" fxShow.gt-sm>
                      <span class="accent">Fakturanr</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" fxShow="false" fxShow.gt-sm>
                      <span *ngIf="element?.InvoiceDocument?.Guid || element?.InvoiceDocument?.Url; else noUrlComp">
                        <a href="" (click)="openInvoiceDocument(element?.InvoiceDocument, $event)">{{ element.InvoiceNumber }}</a>
                      </span>
                      <ng-template #noUrlComp>
                        <span>{{ element.InvoiceNumber }}</span>
                      </ng-template>
                    </mat-cell>
                  </ng-container>
                  <!-- Totalsumma -->
                  <ng-container matColumnDef="amountcomp">
                    <mat-header-cell *matHeaderCellDef fxShow="false" fxShow.gt-sm>
                      <span class="accent">Totalsumma</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" fxShow="false" fxShow.gt-sm style="text-align: right;">
                      <span *ngIf="element.Customer != null">{{ element.TotalInvoiceAmountIncVat | number:'1.2-2' }}</span>
                    </mat-cell>
                  </ng-container>
                  <!-- Fakturastatus -->
                  <ng-container matColumnDef="invoicestatuscomp">
                    <mat-header-cell *matHeaderCellDef fxShow="false" fxShow.gt-sm>
                      <span class="accent">Fakturastatus</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" fxShow="false" fxShow.gt-sm>
                      <span>{{ element.Status?.Name }}</span>
                    </mat-cell>
                  </ng-container>
                  <!-- Förfallodatum -->
                  <ng-container matColumnDef="paymentduecomp">
                    <mat-header-cell *matHeaderCellDef fxShow="false" fxShow.gt-sm>
                      <span class="accent">Förfallodatum</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" fxShow="false" fxShow.gt-sm>
                      <span>{{ element.PaymentDue | swedishDate: 'yyyy-MM-dd' }}</span>
                    </mat-cell>
                  </ng-container>
                  <mat-header-row *matHeaderRowDef="displayedColumnsCompany"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: displayedColumnsCompany;"></mat-row>
                </mat-table>
              </div>
            </mat-card-content>
          </mat-card>

          <!-- Alternativt meddelande om inga fakturor finns -->
          <mat-card *ngIf="invoiceData == 0">
            <mat-card-title>
              <h4 class="incomeTextHead accent">Skickade fakturor</h4>
            </mat-card-title>
            <mat-card-subtitle>
              <p class="incomeText">
                Här var det tomt, välj <a href="#/combined-invoice-tool"><span class="accent">Ny faktura</span></a> för att skicka en faktura
              </p>
            </mat-card-subtitle>
            <mat-card-content>
              <div class="d-flex justify-content-center">
                <a mat-button mat-raised-button color="accent" href="#/combined-invoice-tool">Ny faktura</a>
              </div>
            </mat-card-content>
          </mat-card>
        </ng-container>
      </div>

      <!-- Höger kolumn: Meddelanden och Värvningskod -->
      <div class="column">
        <!-- Meddelanden -->
        <anms-member-message-preview></anms-member-message-preview>

        <!-- Värvningskod direkt under meddelanden -->
        <mat-card *ngIf="appId == 1">
          <mat-card-title>
            <h4 class="incomeTextHead accent">Värvningskod</h4>
          </mat-card-title>
          <mat-card-content>
            <div class="col-lg-12">
              <p>Här är din personliga värvningskod:</p>

              <h3>{{user?.ReferralCode}}</h3>

              <!--<p>Ge din värvningskod till en vän som ännu inte är medlem i SAMpoolen, så får din vän 50 % rabatt på avgiften på sin allra första faktura.</p>
              <p>Du får den andra halvan av avgiften från den fakturan insatt som pengar på ditt saldo. Du får sedan 50 % av vår avgift på ALLA fakturor som din vän skickar under hela sin första månad hos oss!</p>
              <p>Koden anges vid registrering av nytt medlemskonto, och du får rabatten när din vän fått betalt för sin faktura.</p>-->
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</div>
